'use client';

import Link from 'next/link';
import { InputItems } from '~/types/entry-members-form';

interface Step3Props {
  isMobile: boolean;
  inputItems: InputItems;
  telErrorMessage: string;
  emailErrorMessage: string;
  onBack: () => void;
  onChangeTel: (tel: string) => void;
  onChangeEmail: (email: string) => void;
}

export default function Step3({
  isMobile,
  inputItems,
  telErrorMessage,
  emailErrorMessage,
  onBack,
  onChangeTel,
  onChangeEmail,
}: Step3Props) {
  return (
    <>
      {/* 電話番号 */}
      <div className="p-horizontal-slide__form">
        <div className="p-horizontal-slide__header">
          <div className="u-flex -items-center u-gap8">
            <span className="c-label -bg-red">必須</span>
            <div className="u-font-bold">電話番号</div>
            <span className="u-color-gray u-fs14">(半角ハイフンなし)</span>
          </div>
        </div>
        <div className="p-horizontal-slide__body">
          <input
            type="tel"
            className={`c-input -inline -no-shadow -border ${
              !isMobile ? 'u-wp90' : ''
            }`}
            placeholder="08012345678"
            value={inputItems.tel}
            onChange={(e) => onChangeTel(e.target.value)}
          />
          <div className="p-entry-form__input__error u-h-1em u-mt8">
            {telErrorMessage}
          </div>
        </div>
      </div>

      <hr className={!isMobile ? 'u-mt20 u-mb40' : 'u-mt10 u-mb20'} />

      {/* メールアドレス */}
      <div className="p-horizontal-slide__form">
        <div className="p-horizontal-slide__header">
          <div className="u-flex -items-center u-gap8">
            <span className="c-label -bg-red">必須</span>
            <div className="u-font-bold">メールアドレス</div>
            <span className="u-color-gray u-fs14">(半角英数)</span>
          </div>
        </div>
        <div className="p-horizontal-slide__body">
          <input
            type="email"
            className={`c-input -inline -no-shadow -border ${
              !isMobile ? 'u-wp90' : ''
            }`}
            placeholder="taro@kenshoku-bank.com"
            value={inputItems.email}
            onChange={(e) => onChangeEmail(e.target.value)}
          />
          <div className="p-entry-form__input__error u-h-1em u-mt8">
            {emailErrorMessage}
          </div>
        </div>
      </div>

      {/* アクション */}
      <div className="p-horizontal-slide__actions">
        <span className="p-horizontal-slide__prev-link u-mb20" onClick={onBack}>
          前に戻る
        </span>
        <div className="u-flex -column">
          <button
            id="confirmation_submit_button"
            type="submit"
            className="c-button -horizontal-slide -arrow-right entry_member_submit"
          >
            応募する
          </button>
          <div
            className={`u-mt8 c-icon -lock_closed u-lh16 ${
              !isMobile ? 'u-fs12' : 'u-fs9'
            }`}
          >
            <Link href="/terms" target="_blank" rel="noopener">
              利用規約
            </Link>
            に同意の上、ボタンを押してください
          </div>
        </div>
      </div>
    </>
  );
}
